import React from 'react';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const fromScratch = ['Pasas horas buscando actividades que luego debes adaptar.', 'Guardas recursos dispersos entre carpetas, archivos, libros y enlaces.', 'Repites las mismas propuestas porque no tienes tiempo de crear alternativas.', 'Preparas evaluación y recuperación como tareas separadas cada vez.', 'La planificación ocupa el tiempo que querías reservar para ti, tu descanso o tu familia.'];
const withLibrary = ['Encuentras fichas, actividades, juegos y evaluaciones organizados para usar.', 'Preparas una clase concreta sin empezar desde una página en blanco.', 'Combinas explicación visual, práctica y evaluación en un mismo sistema.', 'Utilizas versiones A y B cuando necesitas una alternativa para trabajar o recuperar.', 'Llevas al aula recursos que ayudan a comprender, participar y recordar.', 'Recuperas tiempo de planificación sin bajar la calidad de tus clases.'];
export function PainPoints() {
  return <section className="relative py-8 md:py-16 px-4 bg-chem-ice overflow-hidden" data-id="element-129" data-mp="1yyu2myjyvb5c">
      <div aria-hidden="true" className="chem-nodes pointer-events-none absolute inset-0" data-id="element-130" data-mp="1u12e8eij675w" />
      <div className="relative max-w-6xl mx-auto" data-id="element-131" data-mp="27s74wr3x7p43">
        <div className="max-w-4xl mx-auto text-center mb-6 md:mb-10" data-id="element-132" data-mp="23r55a963db1l">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl md:text-4xl font-black text-chem-navy leading-tight mb-3 md:mb-4" data-id="element-133" data-mp="1g1szlj9z3l41">
            La diferencia entre seguir armando todo desde cero y tener una
            biblioteca lista para usar.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-chem-navy/70 font-bold text-sm md:text-lg leading-relaxed" data-id="element-134" data-mp="30hnvrkbw6xy7">
            No necesitas más recursos dispersos. Necesitas un sistema que te
            permita encontrar y utilizar lo que necesitas para cada clase.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 items-start" data-id="element-135" data-mp="226mlrcne69eb">
          <motion.article initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white/70 border border-chem-navy/10 rounded-3xl p-5 md:p-8" data-id="element-136" data-mp="274ef8b3oq3km">
            <h3 className="text-chem-navy/80 font-black text-lg md:text-xl leading-tight mb-5 md:mb-6" data-id="element-137" data-mp="1jfloct1x6lwv">
              Cuando cada clase empieza desde cero
            </h3>
            <ul className="space-y-4" data-id="element-138" data-mp="1o7wre4ryintn">
              {fromScratch.map(item => <li key={item} className="flex items-start gap-3" data-id="element-139" data-mp="qqejlcbvh036">
                  <span className="mt-0.5 shrink-0 rounded-lg bg-chem-navy/10 p-1" data-id="element-140" data-mp="voptto62xclx">
                    <XIcon className="w-4 h-4 text-chem-navy/70 stroke-[3px]" data-id="element-141" data-mp="o6i58r4e5ers" />
                  </span>
                  <span className="text-chem-navy/70 font-semibold text-sm md:text-base leading-relaxed" data-id="element-142" data-mp="j6vt6l0au4kk">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.article>

          <motion.article initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.08
        }} className="bg-chem-petrol rounded-3xl p-6 md:p-9 shadow-2xl shadow-chem-navy/25" data-id="element-143" data-mp="a67f5qawo47o">
            <h3 className="text-white font-black text-xl md:text-2xl leading-tight mb-5 md:mb-6" data-id="element-144" data-mp="3rn8jfta4my4k">
              Con Química Visual
            </h3>
            <ul className="space-y-4" data-id="element-145" data-mp="3imse0e9tpgx2">
              {withLibrary.map(item => <li key={item} className="flex items-start gap-3" data-id="element-146" data-mp="3dnftw1ac6ny6">
                  <span className="mt-0.5 shrink-0 rounded-lg bg-white/15 p-1" data-id="element-147" data-mp="3dpaf7gpisi2s">
                    <CheckCircle2Icon className="w-4 h-4 text-chem-turquoise" data-id="element-148" data-mp="1hkkt8bg3iiuw" />
                  </span>
                  <span className="text-white font-semibold text-sm md:text-base leading-relaxed" data-id="element-149" data-mp="1ll4nn79ab8dc">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.article>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mt-7 md:mt-10" data-id="element-150" data-mp="xwbrpasnx0iq">
          <p className="text-chem-navy font-black text-lg md:text-2xl leading-snug max-w-3xl mx-auto mb-5 md:mb-7" data-id="element-151" data-mp="ovndaezcwy5b">
            Menos tiempo buscando y preparando. Más tiempo enseñando y
            acompañando a tus estudiantes.
          </p>
          <motion.button animate={{
          boxShadow: ['0 0 15px rgba(22,163,74,0.2)', '0 0 30px rgba(22,163,74,0.5)', '0 0 15px rgba(22,163,74,0.2)'],
          scale: [1, 1.02, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} whileHover={{
          scale: 1.04
        }} whileTap={{
          scale: 0.97
        }} onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="w-full max-w-md bg-chem-green hover:bg-green-700 text-white font-black text-sm md:text-xl py-5 md:py-6 px-6 rounded-2xl shadow-[0_10px_30px_rgba(22,163,74,0.3)] uppercase tracking-tight transition-colors" data-id="element-152" data-mp="2j9y24nfybsb3">
            Quiero tener los recursos listos
          </motion.button>
        </motion.div>
      </div>
    </section>;
}